import React, { useState, useCallback } from "react";
import { useLeadFilters } from "./useLeadFilters";
import FilterPopover from "./FilterPopover";
import ActiveFilterChips from "./ActiveFilterChips";
import { ChevronDown, ListFilter, RotateCcw, Search, X } from "lucide-react";

function LeadFilters({ search, setSearch, activeFilterCount, filters, setFilters, workspaceId, pipelineId, customFields = [] }) {
  const {
    stages,
    users,
    workflowStages,
    applyFilter,
    removeFilterChip,
    resetFilters,
    activeFilterChips,
  } = useLeadFilters(filters, setFilters, search, setSearch, activeFilterCount, workspaceId, pipelineId, customFields);

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleToggleFilter = useCallback(() => setIsFilterOpen((prev) => !prev), []);
  const handleCloseFilter = useCallback(() => setIsFilterOpen(false), []);

  const hasNothingToSaveOrReset = activeFilterCount === 0 && search.trim() === "";

  return (
    <div className="crm-filterbar">
      <div className="crm-filterbar-row">
        <label className="ws-searchbox crm-lead-search">
          <Search size={15} aria-hidden="true" />
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            aria-label="Search leads"
            placeholder="Search name, email, phone or company"
          />
          {search && <button type="button" className="crm-search-clear" onClick={() => setSearch("")} aria-label="Clear search"><X size={13} /></button>}
        </label>

        <div className="ws-dd-root">
          <button type="button" onClick={handleToggleFilter} className="ws-sort" aria-expanded={isFilterOpen} aria-haspopup="dialog">
            <ListFilter size={15} className="ws-sort-icon" aria-hidden="true" />
            Filter
            {activeFilterCount > 0 && <span className="ws-seg-count crm-filter-count ws-num">{activeFilterCount}</span>}
            <ChevronDown size={14} className="ws-dd-chev" aria-hidden="true" />
          </button>
          <FilterPopover
            isOpen={isFilterOpen}
            onClose={handleCloseFilter}
            stages={stages}
            users={users}
            workflowStages={workflowStages}
            filters={filters}
            onApply={applyFilter}
            customFields={customFields}
          />
        </div>

        <button
          type="button"
          onClick={resetFilters}
          disabled={hasNothingToSaveOrReset}
          title="Reset filters"
          aria-label="Reset filters"
          className="crm-icon-btn crm-icon-btn--sm"
        >
          <RotateCcw size={14} strokeWidth={2} />
        </button>
      </div>

      {activeFilterChips.length > 0 && (
        <ActiveFilterChips chips={activeFilterChips} onRemoveChip={removeFilterChip} />
      )}
    </div>
  );
}

export default React.memo(LeadFilters);
